module.exports = __webpack_public_path__ + "static/media/Thursday.5391a9ac.webp";